<template>
  
  <div class="course-card">
    <figure class="course-card__image">
      <template v-if="course.profile_pic">
        <img :src="course.profile_pic" />
      </template>
      <template v-else>
        <img :src="`https://fakeimg.pl/350x200/?text=${course.first_name + ' ' + course.last_name}`" />
      </template>

    </figure>
    <div class="course-card__body">

      <h3 class="course-card__title">
        {{course.first_name + ' ' + course.last_name}}
      </h3>

      <span class="course-card__purchasecounter" >
        No. of courses: {{course.number_of_courses}}
      </span>
    </div>
  </div>
</template>

<script>
export default {
  name: "CourseCard",

  props: {
    course: {
      type: Object,
      required: true,
    },
    mycourse: {
      type: Boolean,
    }
  },
  data() {
    return {
      user: null,
    };
  },
  filters: {
    truncate: function (text, length, suffix) {
      if (text.length > length) {
        return text.substring(0, length) + suffix;
      } else {
        return text;
      }
    },
  },
};
</script>